import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class ReferringPhysicianLetterDataService {
    
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public sendLettersAsync(selectedLineIds: number[], timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ReferringPhysicianLetters/SendLetters', selectedLineIds, timeout);
  }
}
